module.exports = __webpack_public_path__ + "img/gift3-01-c03.997c6426.png";